import {
  IconCalendarMonth,
  IconInkDoubleDrops,
  IconPersonAssist,
  IconPrinter,
  IconPrinterUpgrade,
  IconShieldCheckmark,
} from '@veneer/core';
import { ReactElement } from 'react';

export function getIcon(iconName: string): ReactElement {
  switch (iconName) {
    case 'IconPrinter':
      return <IconPrinter size={60} color="gray12" />;
    case 'IconCalendarMonth':
      return <IconCalendarMonth size={60} color="gray12" />;
    case 'IconPersonAssist':
      return <IconPersonAssist size={60} color="gray12" />;
    case 'IconInkDoubleDrops':
      return <IconInkDoubleDrops size={60} color="gray12" />;
    case 'IconShieldCheckmark':
      return <IconShieldCheckmark size={60} color="gray12" />;
    case 'IconPrinterUpgrade':
      return <IconPrinterUpgrade size={60} color="gray12" />;
    default:
      return <></>;
  }
}
